import React from 'react';
import { Box } from '@mui/material';
import { LogoContainer } from './styled';

// Import delle immagini come moduli
import kipifyLogo from 'src/icons/kipify-logo.png';
import kipifyLogoWhite from 'src/icons/kipify-logo-white.png';

interface LogoProps {
  variant?: 'default' | 'white' | 'mobile';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({
  variant = 'default',
  size = 'medium',
  className,
}) => {
  const getLogoSrc = () => {
    switch (variant) {
      case 'white':
        return kipifyLogoWhite;
      case 'mobile':
        return kipifyLogo; // Usa il logo principale per mobile
      default:
        return kipifyLogo;
    }
  };

  return (
    <LogoContainer size={size} className={className}>
      <img
        src={getLogoSrc()}
        alt="Kipify"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </LogoContainer>
  );
};
